export default __webpack_public_path__ + "static/media/image@3x.545f7d74.png";